import React, { FC, useState, useEffect } from 'react';
import { Row, Col, Input, Button, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { actions as appointmentActions } from 'store/appointment';
import * as _ from 'lodash';
import StoreState from 'models/store';
import { formRules } from 'helpers/formUtils';

import AppointmentCard from '../../AppointmentCard/AppointmentCard';

const HistoryOfFamily: FC<any> = props => {
  const dispatch = useDispatch();
  const { dataProps, initValues, isEditAvailability } = props;
  const originTime = new Date();
  const [isEdit, setIsEdit] = useState<any>();
  const [isAdd, setIsAdd] = useState<any>(false);
  const [i, setI] = useState<any>();
  const arrHistoryOfFamily = dataProps?.detail?.encounters[0]?.obs?.filter(
    item => item?.display?.includes('HISTORY OF FAMILY'),
  );

  const appointmentReducer = useSelector(
    (state: StoreState) => state.appointment,
  );
  const [isSubmit, setIsSubmit] = useState(false);

  const handleEdit = _.debounce(key => {
    setIsEdit(true);
    setI(key);
  }, 50);

  const handleCancel = _.debounce(key => {
    setIsEdit(false);
    setI(key);
  }, 50);

  // const handleSave = _.debounce(key => {
  //   setIsEdit(false);
  //   setI(key);
  // }, 50);

  const onEdit = values => {
    const { historyOfFamily } = values;

    const uuidHistoryOfFamily =
      arrHistoryOfFamily && arrHistoryOfFamily[i]?.uuid;

    const paramsEditHistoryOfFamily = {
      value: historyOfFamily,
    };
    dispatch(
      appointmentActions.handleEditHistoryOfFamily({
        uuidHistoryOfFamily,
        paramsEditHistoryOfFamily,
      }),
    );
    setIsEdit(false);
  };

  const onFinish = values => {
    setIsSubmit(true);
    const { value } = values;

    const paramsCreateHistoryOfFamily = {
      value,
      concept: 'ae6b4504-3f98-4387-a34d-29a7cfb43152',
      obsDatetime: originTime?.toISOString(),
      person: dataProps?.detail?.uuidPerson,
      encounter: dataProps?.detail?.encounters[0]?.uuid,
    };
    dispatch(
      appointmentActions.handleCreateHistoryOfFamily(
        paramsCreateHistoryOfFamily,
      ),
    );
  };

  useEffect(() => {
    if (
      isSubmit === true &&
      appointmentReducer?.isAddCreateHistoryOfFamily === true
    ) {
      setIsAdd(false);
    }
  }, [appointmentReducer?.isAddCreateHistoryOfFamily]);

  return (
    <div className="drug-in-use">
      {initValues?.length > 0 ? (
        <AppointmentCard title="Tiểu sử gia đình">
          {initValues?.map((item, key) => {
            return (
              <Row className="row-1" key={key}>
                <Col xs={24}>
                  <div className="anamnesis-section">
                    <Form onFinish={onEdit}>
                      <div className="anamnesis-section__title" key={key}>
                        <div>
                          <span> </span>
                        </div>
                        <div className="btn-edit">
                          {isEditAvailability &&
                            (isEdit && key === i ? (
                              <>
                                <Button
                                  size="middle"
                                  onClick={() => handleCancel(key)}
                                >
                                  Hủy
                                </Button>{' '}
                                <Button size="middle" htmlType="submit">
                                  Lưu
                                </Button>
                              </>
                            ) : (
                              <Button
                                onClick={() => handleEdit(key)}
                                size="middle"
                              >
                                Sửa
                              </Button>
                            ))}
                        </div>
                      </div>
                      <div className="anamnesis-section__content">
                        <div className="anamnesis-section__content_inside">
                          {isEdit && key === i ? (
                            <Form.Item
                              name="historyOfFamily"
                              preserve={false}
                              rules={formRules}
                              initialValue={item}
                            >
                              <Input />
                            </Form.Item>
                          ) : (
                            <span className="text-have-color-#555555">
                              {item}
                            </span>
                          )}
                        </div>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row>
            );
          })}
        </AppointmentCard>
      ) : (
        <Row className="row-1">
          <Col xs={24}>
            <div className="anamnesis-section">
              <div className="anamnesis-section__title">
                <div>
                  <span>Tiền sử gia đình</span>
                </div>
              </div>
              <div className="no-content">
                <span className="no-content__text">Chưa có thông tin</span>
              </div>
            </div>
          </Col>
        </Row>
      )}

      {isEditAvailability && (
        <div className="anamnesis-add-container">
          {isAdd ? (
            <Form onFinish={onFinish}>
              <div className="anamnesis-input-add">
                <Form.Item name="value" rules={formRules}>
                  <Input
                    size="large"
                    placeholder="Thêm thông tin tiền sử gia đình"
                    ref={input => input && input.focus()}
                  />
                </Form.Item>
              </div>
              <div className="anamnesis-action-add">
                <div className="btn-ok">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={appointmentReducer?.isLoadingCreateHistoryOfFamily}
                  >
                    Lưu
                  </Button>
                </div>
                <div className="btn-cancel">
                  <a
                    className="no-underline"
                    href="#"
                    onClick={() => setIsAdd(!isAdd)}
                  >
                    <span>Hủy</span>
                  </a>
                </div>
              </div>
            </Form>
          ) : (
            <div>
              <Button
                className="rounded-md"
                type="primary"
                onClick={() => setIsAdd(!isAdd)}
              >
                Thêm thông tin
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HistoryOfFamily;
